(ns iris.tags.views
  (:require
   [reagent.core :as reagent]
   [re-frame.core :as re-frame]
   [iris.tags.events :as tags-events]
   [iris.tags.subs :as tags-subs]
   [iris.common :as common]
   [iris.components.chip :refer [chip]]
   [iris.components.switch :refer [switch]]
   [clojure.string :as string]
   [goog.string :as gstring]
   [iris.components.simple-modal :refer [simple-modal]]
  ;;  [herb.core :refer [<class <id]]
   [iris.styles.tags :as $tags]))



(def select-all (atom false))

(defn reset-select-all [e]
  (reset! select-all false))

(defn post-template []
  [:div
   [:div
    {:class "mobile post-wrap topic-wrap"}
    [:article
     {:class "post topic", :id "OP", :itemscope ""}
     [:header [:h2 {:class "post-title"} "promo of a promo second time"]]
     [:div
      {:class "post-body"}
      [:p "testing regular op txt"]
      [:p
       [:a {:href "/p/@OP+1uA3xPZ9", :class "ref pref"} "@OP+1uA3xPZ9"]]]
     [:footer
      {:class "meta"}
      [:div
       [:div
        {:class "signature"}
        [:span
         {:class "post-timeago",
          :data-timestamp "1737125115",
          :data-datetime "2025-01-17T14:45:15Z",
          :data-format "long"}
         [:time
          {:datetime "2025-01-17T14:45:15Z",
           :data-original-title "2025-01-17T14:45:15Z",
           :data-toggle "tooltip",
           :data-reactroot ""}
          "5 minutes ago"]]
        " by "
        [:span {:class "post-author"} " Anonymous"]]

       [:span {:class "divider"} " | "]
       [:span {:class "views"} " 14 views "]
       " | "
       [:span
        {:class "counters"}
        [:span
         {:data-el-index "0",
          :data-nick "@OP",
          :data-forum-ruid "/at-and-t.TLO",
          :data-thread-ruid "+1jhtbkdps",
          :class "vote-reactions-counter",
          :data-downvotes-count "0",
          :data-upvotes-count "0",
          :data-reactions-threshold "100",
          :data-ruid "@OP+1jhtbkdps"}
         [:span
          {:class "sc-brqgnP jaxTcT"}
          [:span "1"]
          " reaction "
          [:span "(+1"]
          "/"
          [:span "-0"]
          ")"]]]
       "|"
       [:span
        {:class "nreplies"}
        [:a {:href "/t/1jhtbkdps"} [:strong " 1 reply"]]
        " ("
        [:span {:title "2025-01-17T14:47:43Z"} "3 minutes ago"]
        ")"]]
      [:span
       {:class "postIdWrap"}
       "Post ID:"
       [:span {:class "postid"} "@OP+1uAVglun"]]]]]
   [:div {:style {:display "flex"
                  :border "1px solid lightgray"
                  :padding "5px"}}

    [:div
     [chip "#oldTag" :css-class $tags/$btn-old-tag :on-click-remove #(println "click remove chip")]
     [chip "#newTag" :css-class $tags/$btn-selected-tag :on-click-remove #(println "click remove chip")]
     [chip "#newTag" :css-class $tags/$btn-new-tag :on-click-remove #(println "click remove chip")]]
    [:div {:style {:display "flex"
                   :flex-direction "column"
                   :justify-content "center"}}
     [:button "▲"]
     [:button "▼"]]]
   [:div {:style {:margin "10px 0"}}
    [:button {:class "btn btn-success" :type "submit"}
     [:i {:class "glyphicon glyphicon-ok-circle"}] " Approve"]]])

(defn tags-edit-modal []
  (let [modal @(re-frame/subscribe [::tags-subs/modal])]
    (when (true? (:display modal))

      [simple-modal
       "Edit / Approve Tags"
       [post-template]
       600
       (fn [e]
         (.preventDefault e)
         (re-frame/dispatch [::tags-events/set-modal-display false]))]))
)

(defn tags-list-options
  ([] (tags-list-options nil))
  ([option] [:div {:style {:text-align "center"}}
             [:div.btn-group.btn-group-lg
              {:role "group"
               :style {:margin "5px"}}
              [:a.btn
               {:title "Pending tags"
                :href "/tags/pending"
                :class (if (= option "pending") "btn-primary" "btn-default")
                :on-click reset-select-all}
               [:i.glyphicon.glyphicon-time {:class (when-not (= option "pending") "text-primary")}] " Pending"]
              [:a.btn
               {:title "Approved tags"
                :href "/tags/approved"
                :class (if (= option "approved") "btn-primary" "btn-default")
                :on-click reset-select-all}
               [:i.glyphicon.glyphicon-ok-circle {:class (when-not (= option "approved") "text-success")}] " Approved"]
              [:a.btn
               {:title "Rejected tags"
                :href "/tags/removed"
                :class (if (= option "removed") "btn-primary" "btn-default")
                :on-click reset-select-all}
               [:i.glyphicon.glyphicon-remove-circle {:class (when-not (= option "removed") "text-danger")}] " Rejected"]
              [:a.btn
               {:title "Blocked tags"
                :href "/tags/blocked"
                :class (if (= option "blocked") "btn-primary" "btn-default")
                :on-click reset-select-all}
               [:i.glyphicon.glyphicon-ban-circle {:class (when-not (= option "blocked") $tags/$text-dark)}] " Blocks"]]]))


(defn tags-view-by-options [options]
  [:div {:style {:text-align "center"
                 :margin-top "1rem"}}
   [:<>
    "View by: " (gstring/unescapeEntities "&nbsp; &nbsp;")
    (when (:tags options) [:<> [:input {:type "radio" :id "tag" :name "viewby" :checked (when (or (empty? (:default options)) (= (:default options) "tag")) "checked")}] [:label {:for "tag"} "Tag"] (gstring/unescapeEntities "&nbsp; &nbsp;")])
    (when (:ruid options) [:<> [:input {:type "radio" :id "ruid" :name "viewby" :checked (when (= (:default options) "ruid") "checked")}] [:label {:for "ruid"} "Ruid"]])
    (when (:scope options) [:<> [:input {:type "radio" :id "scope" :name "viewby" :checked (when (= (:default options) "scope") "checked")}] [:label {:for "scope"} "Scope"]])]])


(defn switchable? [column]
  (let [[k v] column]
    (:switchable v)))


(defn tags-columns-selector []
  (let
   [columns @(re-frame/subscribe [::tags-subs/columns :pending])]
    (reagent/with-let [dropdown (reagent/atom false)]
      [:div.dropdown {:style {:display "inline-block" :float "right"}}
       [:button.btn.btn-default.dropdown-toggle {:type "button"
                                                 :data-toggle "dropdown"
                                                 :style {:width "110px"}
                                                 :on-click #(reset! dropdown (not @dropdown))} "Columns " [:span.caret]]
       (when (true? @dropdown)
         [:ul.dropdown-menu {:role "menu" :style {:position "absolute"
                                                  :right "10px"
                                                  :width "110px"
                                                  :list-style-type "none"
                                                  :padding "5px"
                                                  :background "white"
                                                  :z-index 1
                                                  :border "1px solid lightgray"
                                                  :border-radius "4px"
                                                  :box-shadow "0 6px 12px rgba(0, 0, 0, 0.175)"}}
          (for [[k v] (filter switchable? columns)]
            (let [label (->> (string/split (name k) #"-")
                             (map string/capitalize)
                             (string/join " "))]
              [:li
               [:label
                [:input {:type "checkbox" :name k :checked (:show v) :on-change #(re-frame/dispatch [::tags-events/set-columns :pending k :show (not (:show v))])}]
                label]]))])])))


(defn approve-switch []
  [:<>
   [:label {:class "switch"
            :style {:vertical-align "middle"
                    :margin-bottom 0}}
    [:input {:type "checkbox"
             :checked true ;;(:enabled @form-data)
             :on-change (fn [e]
                        ;;   (on-input-checkbox-change e edit-enabled (:ruid @form-data))
                          )}]
    [:span {:class "slider round" :title "Enable/Disable Rule"}]]])


;; DELETE BTN
;;    [:a.btn.btn-danger
;;     {:title "Click to permanently delete"
;;      :on-click (fn [e]
;;                 ;;  (on-delete e (:ruid @form-data) true)
;;                  )
;;      :style {:vertical-align "middle"}}
;;     [:i.glyphicon.glyphicon-remove]]
(def post-id "12345")







(defn on-change-checkbox-select-all [e]
  (doseq [n (goog.array.toArray (.querySelectorAll js/document "input[name=tag]"))]
    (set! (.-checked n) (not @select-all)))
  (reset! select-all (not @select-all))
  (re-frame/dispatch [::tags-events/set-all-rows-selected (.-checked (.-target e))]) )


(defn on-submit-approve-all [e form-el]
  (.preventDefault e)
  (let [f (new js/FormData form-el)
        tags (vec (map keyword (.getAll f "tag")))]
    (re-frame/dispatch [::tags-events/approve-tags tags])))


(defn on-submit-reject-all [e form-el]
  (.preventDefault e)
  (let [f (new js/FormData form-el)
        tags (vec (map keyword (.getAll f "tag")))]
    (re-frame/dispatch [::tags-events/reject-tags tags])))


(defn tags-pending-list []
;;   username, created, valid until, ip address, user agent, idle time/last seen, role (s)
  ;; (reagent/with-let [form-data (atom nil)]
    (let [data @(re-frame/subscribe [::tags-subs/data])
        ;; selection @(re-frame/subscribe [::tags-subs/selection])
          columns @(re-frame/subscribe [::tags-subs/columns :pending])
          form-el (atom nil)]

      [:form {:ref (fn [el] (reset! form-el el))
              :on-submit (fn [e] (.preventDefault e))} ;; on-submit preventDefault must be done otherwise weird things start to happen, form gets submitted when it shouldn't and url changes to /pending?tag={postid}
       [:div {:class "table-responsive"
              :style {:margin "20px 0 0"}}
        [:table {:class
                 (str "table table-striped table-hover" " " $tags/$table-grid)
                 :style ($tags/pending-grid columns)}
         [:thead
          [:tr
           [:th {:scope "col"} [:input {:type "checkbox"
                                        :on-change on-change-checkbox-select-all}]]
           (when (:show (:ruid columns)) [:th {:scope "col"} "Ruid"])
           (when (:show (:title columns)) [:th {:scope "col"} "Title"])
           (when (:show (:body columns)) [:th {:scope "col"} "Post"])
           (when (:show (:tags columns)) [:th {:scope "col"
                                               :style {:min-width "200px"}} "Tag"])
           ;;  [:th {:scope "col"} "Order"]
           (when (:show (:time-submitted columns)) [:th {:scope "col"} "Time Submitted"])
           (when (:show (:tags-approved columns)) [:th {:scope "col"} "Tags Approved"])
           ;;  [:th {:scope "col"} "Edit"]
           [:th {:scope "col"} "Approve"]
           [:th {:scope "col"} "Reject"]]]
         [:tbody
          (for [[index d] data]
            ;; (println "tag row" index d (:index @selection))
            (let [;; selected? (= index (:index selection))
                  selected? (:selected d)
                  any-selected? (some (fn [t] (:selected t)) (:order-tags d))]
              ;;  (when selected? (println "any-selected?:::" any-selected? (:order-tags d)))
              [:tr {:key ""
                    :on-click (fn [e]
                                (println "click row" index)
                                (if (not selected?)
                                  (do
                                    ;; (re-frame/dispatch [::tags-events/set-selection-kv :index index])
                                    (re-frame/dispatch [::tags-events/set-row-selected index true])
                                    (when (empty? (:order-tags d))
                                      (re-frame/dispatch [::tags-events/set-order-tags index (:tags d) (:new-tags d)])))
                                  (re-frame/dispatch [::tags-events/set-row-selected index false])))
                    :class (when selected? "selected")}
               [:td [:input {:type "checkbox" :id "" :name "tag" :value index :checked selected?}]]
               (when (:show (:ruid columns)) [:td (:ruid d)])
               (when (:show (:title columns)) [:td.mob-full-row (:title d)])
               (when (:show (:body columns)) [:td.mob-full-row (if selected? (:body d) (:excerpt d))])
               (when (:show (:tags columns)) [:td.mob-full-row
                                              [:<>
                                               (if selected?
                                                 (for [[tag-index tag] (map-indexed vector (:order-tags d))]
                                                   [chip
                                                    (str "#" (:tag tag))
                                                    :css-class (cond
                                                                 (= (:selected tag) true) $tags/$btn-selected-tag
                                                                 (= (:approved tag) false) $tags/$btn-new-tag
                                                                 (= (:approved tag) true) $tags/$btn-old-tag)
                                                    :on-click #(re-frame/dispatch [::tags-events/update-order-tags index tag-index {:selected (not (:selected tag))}])
                                                    :on-click-remove (if (= (:approved tag) false) #(re-frame/dispatch [::tags-events/remove-order-tags index tag-index]) nil)])
                                                 (for [new-tag (:new-tags d)]
                                                   [chip
                                                    (str "#" new-tag)
                                                    :css-class "btn-new-tag"
                                                    :stop-propagation? false
                                                    :on-click-remove #(println (str "click remove chip" "#" new-tag))]))]

                                              ;; [:div
                                              ;;  {:class "controls",
                                              ;;   :style {:display "flex" :flex-flow "column" :align-items "center" :gap "10" :right "0" :color "black"}}
                                              ;;  [:button {:style {:flex "1 0 auto"}
                                              ;;            :on-click #(re-frame/dispatch [::tags-events/move-selected-order-tags-to-start index])} "▲"]
                                              ;;  [:button {:style {:flex "1 0 auto"}
                                              ;;            :on-click #(re-frame/dispatch [::tags-events/move-up-selected-order-tags index])} "▲"]
                                              ;;  [:button {:style {:flex "1 0 auto"}
                                              ;;            :on-click #(re-frame/dispatch [::tags-events/move-down-selected-order-tags index])} "▼"]
                                              ;;  [:button {:style {:flex "1 0 auto"}
                                              ;;            :on-click #(re-frame/dispatch [::tags-events/move-selected-order-tags-to-end index])} "▼"]]

                                              (when (and selected? any-selected?)
                                                [:div {:style {:text-align "left" :margin-top "5px"}}
                                                 [:div
                                                  {;; :style "/* display: flex; */flex-flow: row;align-items: center;right: 0px;color: black;margin-right: 5px;",
                                                   :style {:margin-right "5px"}
                                                   :class "btn-group controls"}
                                                  [:button
                                                   {:class $tags/$btn-control-tag
                                                    :style {:flex "1 0 auto" :color "black" :padding "4px 10px"}
                                                    :on-click (fn [e]
                                                                (.stopPropagation e)
                                                                (re-frame/dispatch [::tags-events/move-selected-order-tags-to-start index]))}
                                                   [:svg {:width "20" :height "20" :viewBox "0 0 20 20" :xmlns "http://www.w3.org/2000/svg"}
                                                    [:polygon {:points "10,10 17,14 17,6" :fill "black"}]
                                                    [:polygon {:points "3,10 10,14 10,6" :fill "black"}]]]
                                                  [:button
                                                   {:class $tags/$btn-control-tag
                                                    :style {:flex "1 0 auto" :color "black" :padding "4px 10px"}
                                                    :on-click (fn [e]
                                                                (.stopPropagation e)
                                                                (re-frame/dispatch [::tags-events/move-up-selected-order-tags index]))}
                                                   [:svg {:width "20" :height "20" :viewBox "0 0 20 20" :xmlns "http://www.w3.org/2000/svg"}
                                                    [:polygon {:points "14,6 6,10 14,14" :fill "black"}]]]
                                                  [:button
                                                   {:class $tags/$btn-control-tag
                                                    :style {:flex "1 0 auto" :color "black" :padding "4px 10px"}
                                                    :on-click (fn [e]
                                                                (.stopPropagation e)
                                                                (re-frame/dispatch [::tags-events/deselected-all-order-tags index]))}
                                                   [:svg {:width "20" :height "20" :viewBox "0 0 20 20" :xmlns "http://www.w3.org/2000/svg"}
                                                    [:rect {:x "7" :y "7" :width "6" :height "6" :fill "black"}]]]
                                                  [:button
                                                   {:class $tags/$btn-control-tag
                                                    :style {:flex "1 0 auto" :color "black" :padding "4px 10px"}
                                                    :on-click (fn [e]
                                                                (.stopPropagation e)
                                                                (re-frame/dispatch [::tags-events/move-down-selected-order-tags index]))}
                                                   [:svg {:width "20" :height "20" :viewBox "0 0 20 20" :xmlns "http://www.w3.org/2000/svg"}
                                                    [:polygon {:points "6,6 14,10 6,14" :fill "black"}]]]
                                                  [:button
                                                   {:class $tags/$btn-control-tag
                                                    :style {:flex "1 0 auto" :color "black" :padding "4px 10px"}
                                                    :on-click (fn [e]
                                                                (.stopPropagation e)
                                                                (re-frame/dispatch [::tags-events/move-selected-order-tags-to-end index]))}
                                                   [:svg {:width "20" :height "20" :viewBox "0 0 20 20" :xmlns "http://www.w3.org/2000/svg"}
                                                    [:polygon {:points "3,6 10,10 3,14" :fill "black"}]
                                                    [:polygon {:points "10,6 17,10 10,14" :fill "black"}]]]]])])
               ;;  [:td [:div
               ;;        {:class "controls",
               ;;         :style {:display "flex" :flex-flow "column" :align-items "center" :gap "10" :right "0" :color "black"}}
               ;;        [:button {:style {:flex "1 0 auto"}
               ;;                  :on-click #(re-frame/dispatch [::tags-events/move-selected-order-tags-to-start index])} "▲"]
               ;;        [:button {:style {:flex "1 0 auto"}
               ;;                  :on-click #(re-frame/dispatch [::tags-events/move-up-selected-order-tags index])} "▲"]
               ;;        [:button {:style {:flex "1 0 auto"}
               ;;                  :on-click #(re-frame/dispatch [::tags-events/move-down-selected-order-tags index])} "▼"]
               ;;        [:button {:style {:flex "1 0 auto"}
               ;;                  :on-click #(re-frame/dispatch [::tags-events/move-selected-order-tags-to-end index])} "▼"]]]

               (when (:show (:time-submitted columns)) [:td "1736980989"])
               (when (:show (:tags-approved columns)) [:td "2"])
               [:td
                ;;    [switch false #(println "on change")]
                ;; [:a {:class "btn btn-success"
                ;;      :on-click #(re-frame/dispatch [::tags-events/set-modal-display true])} [:i {:class "glyphicon glyphicon-ok-circle"}]]
                [:a {:class "btn btn-success"
                     :on-click
                     ;;  #(re-frame/dispatch [::tags-events/approve index])
                     (fn [e] (.stopPropagation e) (re-frame/dispatch [::tags-events/approve index]))} [:i {:class "glyphicon glyphicon-ok-circle"}]]]
               [:td [:a {:class "btn btn-danger"
                         :on-click
                         (fn [e] (.stopPropagation e) (re-frame/dispatch [::tags-events/reject index]))} [:i {:class "glyphicon glyphicon-remove-circle"}]]]]))]]

        [:button {:class "btn btn-success"
                ;; :type "submit"
                  :on-click (fn [e] (on-submit-approve-all e @form-el))}
         [:i {:class "glyphicon glyphicon-ok-circle"}] " Approve All"]
        " "
        [:button {:class "btn btn-danger"
                  ;; :type "submit"
                  :on-click (fn [e] (on-submit-reject-all e @form-el))}
         [:i {:class "glyphicon glyphicon-remove-circle"}] " Reject All"]]])
        ;;  )
  )


(defn tags-approved-list []
  [:form {;; :on-submit on-submit-block-all
          :on-submit (fn [e] (.preventDefault e))}
   [:div {:class "table-responsive"
          :style {:margin "20px 0 0"}}
    [:table {:class "table table-striped table-hover"}
     [:thead
      [:tr
       [:th {:scope "col"} [:input {:type "checkbox"
                                    :on-change on-change-checkbox-select-all}]]
       [:th {:scope "col"} "Tag"]
       [:th {:scope "col"} "Ruid"]
       [:th {:scope "col"} "Reject"]]]
     [:tbody
      [:tr {:key ""}
       [:td [:input {:type "checkbox" :id "" :name "tag" :value "#sometag"}]]
       [:td "#someTag"]
       [:td [chip "@OP+67890" :on-click-remove #(println (str "click remove chip" post-id))]]
       [:td
        [:a {:class "btn btn-danger"} [:i {:class "glyphicon glyphicon-remove-circle"}]]
    ;;    [switch true #(println "on change")]
        ]]

      [:tr {:key ""}
       [:td [:input {:type "checkbox" :id "" :name "tag" :value "#mytag"}]]
       [:td "#myTag"]
       [:td
        [chip "@OP+12345" :on-click-remove #(println (str "click remove chip" post-id))]
        [chip "@abc+defgh" :on-click-remove #(println (str "click remove chip" post-id))]]
       [:td
        [:a {:class "btn btn-danger"} [:i {:class "glyphicon glyphicon-remove-circle"}]]
          ;;    [switch true #(println "on change")]
        ]]

    ;;  [:tr {:key ""}
    ;;   [:td "2."]
    ;;   [:td "#someTag"]
    ;;   [:td [chip] [chip] [chip] [chip] [chip] [chip]]
    ;;   [:td [approve-switch]]]
      ]]]
   [:button {:class "btn btn-danger"
             :type "submit"}
    [:i {:class "glyphicon glyphicon-remove-circle"}] " Reject All"]])


(defn tags-removed-list []
  [:form {
          ;; :on-submit on-submit-block-all
          :on-submit (fn [e] (.preventDefault e))
          }
   [:div {:class "table-responsive"
          :style {:margin "20px 0 0"}}
    [:table {:class "table table-striped table-hover"}
     [:thead
      [:tr
       [:th {:scope "col"} [:input {:type "checkbox"
                                    :on-change on-change-checkbox-select-all}]]
       [:th {:scope "col"} "Tag"]
       [:th {:scope "col"} "Ruid"]
       [:th {:scope "col"} "Approve"]
       [:th {:scope "col"} "Block"]]]
     [:tbody
      [:tr {:key ""}
       [:td [:input {:type "checkbox" :id "" :name "tag" :value "#sometag"}]]
       [:td "#someTag"]
       [:td [chip "@OP+67890" :on-click-remove #(println (str "click remove chip" post-id))]]

       [:td [:a {:class "btn btn-success"} [:i {:class "glyphicon glyphicon-ok-circle"}]]]

       [:td
        [:a {:class 
            ;;  "btn btn-dark"
             $tags/$btn-dark
             } [:i {:class "glyphicon glyphicon-ban-circle"}]]
    ;;    [switch true #(println "on change")]
        ]]


[:tr {:key ""}
 [:td [:input {:type "checkbox" :id "" :name "tag" :value "#sometag"}]]
 [:td "#myTag"]
 [:td
  [chip "@OP+12345" :on-click-remove #(println (str "click remove chip" post-id))]
  [chip "@zx+qwerty" :on-click-remove #(println (str "click remove chip" post-id))]]

 [:td [:a {:class "btn btn-success"} [:i {:class "glyphicon glyphicon-ok-circle"}]]]

 [:td
  [:a {:class 
      ;;  "btn btn-dark"
       $tags/$btn-dark
       } [:i {:class "glyphicon glyphicon-ban-circle"}]]
    ;;    [switch true #(println "on change")]
  ]]

    ;;  [:tr {:key ""}
    ;;   [:td "2."]
    ;;   [:td "#someTag"]
    ;;   [:td [chip] [chip] [chip] [chip] [chip] [chip]]
    ;;   [:td [approve-switch]]]
      ]]]
   [:button {:class "btn btn-success"
             :type "submit"}
    [:i {:class "glyphicon glyphicon-ok-circle"}] " Approve All"]
   " "
   [:button {:class 
            ;;  "btn btn-dark"
             $tags/$btn-dark
             :type "submit"}
    [:i {:class "glyphicon glyphicon-ban-circle"}] " Block All"]])



  (defn tags-blocked-list []
    [:form {
            ;; :on-submit on-submit-block-all
            :on-submit (fn [e] (.preventDefault e))
            }
     [:div {:class "table-responsive"
            :style {:margin "20px 0 0"}}
      [:table {:class "table table-striped table-hover"}
       [:thead
        [:tr
         [:th {:scope "col"} [:input {:type "checkbox"
                                      :on-change on-change-checkbox-select-all}]]
         [:th {:scope "col"} "Tag"]
        ;;  [:th {:scope "col"} "Ruid"]
         [:th {:scope "col"} "Scope"]
         [:th {:scope "col"} "Edit"]
         [:th {:scope "col"} "Delete"]]]
       [:tbody
        [:tr {:key ""}
         [:td [:input {:type "checkbox" :id "" :name "tag" :value "#sometag"}]]
         [:td "#someTag"]
        ;;  [:td [chip "@OP+12345" #(println "click chip") #(println (str "click remove chip" post-id))]]
         [:td [:code ".ALL"]]
         [:td [:button.btn.btn-primary [:i {:class "glyphicon glyphicon-edit"}]]]
         [:td
          [:a {:class "btn btn-danger"} [:i {:class "glyphicon glyphicon-remove-circle"}]]
      ;;    [switch true #(println "on change")]
          ]]

        [:tr {:key ""}
         [:td [:input {:type "checkbox" :id "" :name "tag" :value "#sometag"}]]
         [:td "#myTag"]
        ;;  [:td
        ;;   [chip "@OP+67890" #(println "click chip") #(println (str "click remove chip" post-id))]
        ;;   [chip "@az+nmjkui" #(println "click chip") #(println (str "click remove chip" post-id))]]
         [:td [:code ".ALL"]]
         [:td [:button.btn.btn-primary [:i {:class "glyphicon glyphicon-edit"}]]]
         [:td
          [:a {:class "btn btn-danger"} [:i {:class "glyphicon glyphicon-remove-circle"}]]
              ;;    [switch true #(println "on change")]
          ]]
      ;;  [:tr {:key ""}
      ;;   [:td "2."]
      ;;   [:td "#someTag"]
      ;;   [:td [chip] [chip] [chip] [chip] [chip] [chip]]
      ;;   [:td [approve-switch]]]
        ]]]
     [:button {:class "btn btn-danger"
               :type "submit"}
      [:i {:class "glyphicon glyphicon-remove-circle"}] " Delete All"]])





(defn tags-panel []
;;   [:div "tags panel"]

  [:<>
   [common/admin-top-bar]
   [common/navbar]
   [:div.container
    [common/spinner]
    [:h1.text-center "Tag Management"]
    [tags-list-options]]])

(defn tags-pending-panel []
  [:<>
   [common/admin-top-bar]
   [common/navbar]
   [:div.container {:style {:width "100%"} }
    [common/spinner]
    [:h1.text-center "Tag Management"]
    [tags-edit-modal]
    [tags-list-options "pending"]
    [tags-view-by-options {:tags false :ruid true :scope false :default "ruid" }]
    [tags-columns-selector]
    [:div.row
     [:div.col-sm-12
      [tags-pending-list]]]]])

(defn tags-approved-panel []
  [:<>
   [common/admin-top-bar]
   [common/navbar]
   [:div.container
    [common/spinner]
    [:h1.text-center "Tag Management"]
    [tags-list-options "approved"]
    [tags-view-by-options {:tags true :ruid true :scope false}]
    [:div.row
     [:div.col-sm-12
      [tags-approved-list]]]]])

(defn tags-removed-panel []
  [:<>
   [common/admin-top-bar]
   [common/navbar]
   [:div.container
    [common/spinner]
    [:h1.text-center "Tag Management"]
    [tags-list-options "removed"]
    [tags-view-by-options {:tags true :ruid true :scope false}]
    [:div.row
     [:div.col-sm-12
      [tags-removed-list]]]]])

(defn tags-blocked-panel []
  [:<>
   [common/admin-top-bar]
   [common/navbar]
   [:div.container
    [common/spinner]
    [:h1.text-center "Tag Management"]
    [tags-list-options "blocked"]
    [tags-view-by-options {:tags true :ruid false :scope true}]
    [:div.row
     [:div.col-sm-12
      [tags-blocked-list]]]]])